// @ts-strict-ignore
import apisauce from 'apisauce'
import { TokensV2ApiFactory, Configuration } from '@dialogue/engage'
import { select, call } from 'typed-redux-saga'

import Config from 'APP/Config'
import { RootState } from 'APP/Store/CreateStore'

export const selectAccessToken = (state: RootState) => state.login.accessToken

export function* getClientConfig() {
  const accessToken = yield* select(selectAccessToken)

  if (!accessToken) {
    throw new Error('Missing access token')
  }

  if (!Config.ENGAGE_DOMAIN) {
    throw new Error('Engage domain is not set')
  }

  return new Configuration({
    accessToken,
    basePath: Config.ENGAGE_DOMAIN,
  })
}

export function* getAxiosClient() {
  const accessToken = yield* select(selectAccessToken)

  if (!accessToken) {
    throw new Error('Missing access token')
  }

  if (!Config.ENGAGE_DOMAIN) {
    throw new Error('Engage domain is not set')
  }

  const apiClient = apisauce.create({
    baseURL: Config.ENGAGE_DOMAIN,
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return apiClient.axiosInstance
}

export function* getTokensApi() {
  const axiosInstance = yield* call(getAxiosClient)
  return TokensV2ApiFactory(yield* call(getClientConfig), '', axiosInstance)
}
